import React, { useState, useEffect, useCallback } from "react";
import request from '../../../utils/Request.utils';
import Paging from "../../component/Paging";
import { ToastContainer, toast } from 'react-toastify';
import Modal from '../../component/Modal';

const FaqCate = () => {
  const [categories, setCategories] = useState([]);
  const [newCategory, setNewCategory] = useState('');
  const [loading, setLoading] = useState(true);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const successHandler = useCallback((response) => {
    if (response.messageCode === 200) {
      setCategories(response.data.data_list);
      setLoading(false);
    } else {
      toast.error("분류 정보를 불러올 수 없습니다.");
      setLoading(false);
    }
  }, []);

  const errorHandler = useCallback((error) => {
    toast.error("데이터를 불러오는 중 오류가 발생했습니다.");
    setLoading(false);
  }, []);

  const fetchCategories = useCallback(() => {
    setLoading(true);
    request.get("/common/code/board_title_ty", {}, successHandler, errorHandler);
  }, [successHandler, errorHandler]);

  useEffect(() => {
    fetchCategories();
  }, [fetchCategories]);

  const handleAddCategory = async () => {
    if (newCategory.trim() === '') {
      toast.error("분류명을 입력해주세요.");
      return;
    }

    try {
      const successHandler = (response) => {
        toast.success("분류가 성공적으로 추가되었습니다.");
        setNewCategory('');
        fetchCategories();
      };

      const errorHandler = (error) => {
        console.log(error)
        toast.error("분류 추가 중 오류가 발생했습니다.");
      };

      const formData = new FormData();
      formData.append("code_gr", 'board_title_ty');
      formData.append("code_nm_kr", newCategory);

      await request.put("/common/code", formData, successHandler, errorHandler);

    } catch (error) {
      toast.error("분류 추가 중 오류가 발생했습니다.");
    }
  };

  const handleSelectCategory = (comm_code) => {
    setSelectedCategories(prevSelectedCategories =>
      prevSelectedCategories.includes(comm_code)
        ? prevSelectedCategories.filter(id => id !== comm_code)
        : [...prevSelectedCategories, comm_code]
    );
  };

  const handleSelectAll = () => {
    if (selectedCategories.length === categories.length) {
      setSelectedCategories([]);
    } else {
      setSelectedCategories(categories.map(category => category.comm_code));
    }
  };

  const openModal = () => setModalIsOpen(true);
  const closeModal = () => setModalIsOpen(false);

  const handleDelete = async () => {
    try {
      const successHandler = (response) => {
        toast.success("분류가 성공적으로 삭제되었습니다.");
        fetchCategories();
        setSelectedCategories([]);
      };

      const errorHandler = (error) => {
        console.log(error)
        toast.error("분류 삭제 중 오류가 발생했습니다.");
      };
      await request.del("/common/code/delete", { comm_codes: selectedCategories }, successHandler, errorHandler);

    } catch (error) {
      toast.error("분류 삭제 중 오류가 발생했습니다.");
    } finally {
      closeModal();
    }
  };

  return (
    <main>
      <h2 className="adm_com_pg_tit">문의 분류 관리</h2>
      <div className="adm_com_pg_content">
        <div className="adm_com_board_list__top">
          <div className="adm_com_board_search">
            <article className='search'>
              <input
                type="search"
                placeholder='추가할 문의분류를 입력해 주세요'
                className="input s type_search"
                value={newCategory}
                onChange={(e) => setNewCategory(e.target.value)}
              />
              <button className="adm_com_btn blue" onClick={handleAddCategory}>추가</button>
            </article>
          </div>
        </div>
        <div className="adm_com_btn_wrap">
          <button className="adm_com_btn gray" onClick={openModal}>선택삭제</button>
        </div>
        {loading ? (
          <p>Loading...</p>
        ) : (
          <table className='adm_com_board_list'>
            <colgroup>
              <col width="5%" />
              <col width="10%" />
              <col width="80%" />
              <col width="5%" />
            </colgroup>
            <thead>
              <tr>
                <th>
                  <div className="check">
                    <input
                      type="checkbox"
                      id="chk01"
                      className="adm_com_chk"
                      onChange={handleSelectAll}
                      checked={selectedCategories.length === categories.length}
                    />
                    <label htmlFor="chk01" />
                  </div>
                </th>
                <th>번호</th>
                <th>분류명</th>
                <th>관리</th>
              </tr>
            </thead>
            <tbody>
              {categories.map((category, index) => (
                <tr key={category.comm_code}>
                  <td>
                    <div className="check">
                      <input
                        type="checkbox"
                        id={`chk${index + 2}`}
                        className="adm_com_chk"
                        checked={selectedCategories.includes(category.comm_code)}
                        onChange={() => handleSelectCategory(category.comm_code)}
                      />
                      <label htmlFor={`chk${index + 2}`} />
                    </div>
                  </td>
                  <td>{index + 1}</td>
                  <td>{category.code_nm}</td>
                  <td>
                    <button
                      className="adm_com_btn gray line"
                      onClick={openModal}
                    >
                      삭제
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        <Paging />
      </div>
      <Modal
        open={modalIsOpen}
        close={closeModal}
        type="confirm"
        popSize="s"
        title="삭제 확인"
        description="선택된 분류를 삭제하시겠습니까?"
      >
        <div className="btn_container">
          <button className="adm_com_btn blue" onClick={handleDelete}>삭제</button>
          <button className="adm_com_btn gray" onClick={closeModal}>취소</button>
        </div>
      </Modal>
      <ToastContainer />
    </main>
  );
};

export default FaqCate;
